import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/app/Main.vue'
import SecureLevel from '../views/app/SecureLevel.vue'
import Board from '@/views/app/Board.vue'
import PrivacyPolicy from '@/views/app/PrivacyPolicy.vue'
import Infou from '@/views/app/Infou.vue'
import User from '@/views/app/User.vue'
import Agree from '@/views/app/main/Agree.vue'
import InputInfo from '@/views/app/main/InputInfo.vue'
import CheckInfo from '@/views/app/main/CheckInfo.vue'
import SelectIdc from '@/views/app/main/SelectIdc.vue'
import SimpleLayout from '@/layout/SimpleLayout.vue'
import AppLayout from '@/layout/AppLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: SimpleLayout,
    redirect: 'home',
    children:[
      {
        name: 'nscauthorize',
        path: 'nscauthorize',
        component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
      },
      {
        name: 'home',
        path: 'home',
        component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
      },
      {
        name: 'request',
        path: 'request',
        component: () => import(/* webpackChunkName: "about" */ '../views/Request.vue')
      },
      {
        name: 'dailyPermitAuth',
        path: 'daily-permit/auth',
        component: () => import('../views/dailyPermit/DailyPermitAuth.vue')
      },
      {
        name: 'dailyPermitInput',
        path: 'daily-permit/input',
        component: () => import('../views/dailyPermit/DailyPermitInput.vue')
      },
      {
        // 외부(비로그인) 공개 조회 페이지 — 승인/반려 알림 링크 진입점 (엑셀 다운로드)
        name: 'dailyPermitView',
        path: 'daily-permit/view',
        component: () => import('../views/dailyPermit/DailyPermitDetail.vue')
      },
      {
        name: 'employeeRequest',
        path: 'employeeRequest',
        component: () => import(/* webpackChunkName: "about" */ '../views/EmployeeRequest.vue')
      },
      {
        name: 'manualEnter',
        path: 'manualEnter',
        component: () => import(/* webpackChunkName: "about" */ '../views/ManualEnter.vue')
      },
      // {
      //   name: 'check',
      //   path: 'check',
      //   component: () => import(/* webpackChunkName: "about" */ '../views/Check.vue')
      // },
      {
        name: 'qrScan',
        path: 'qrScan',
        component: () => import(/* webpackChunkName: "about" */ '../views/QRScan.vue')
      },
      {
        name: 'healthCheck',
        path: 'monitor/l7check',
        component: () => import(/* webpackChunkName: "about" */ '../views/HealthCheck.vue')
      },
      {
        name: 'app',
        path: 'app',
        component: AppLayout,
        children: [
          {
            name: 'main',
            path: 'main',
            component: Main,
            beforeEnter: (to, from, next) => {
              //TODO : 토큰 정보와, 현재 로그인 한 emp 정보가 다를 경우 logout 처리
              window.store.dispatch("auth/validation")
                .then((result) => {
                  if(result) {
                    //임직원이 다른 임직원 이름으로 출입신청을 못하게 방지
                    if(window.store.state.login.empEmail != null && window.store.state.login.empEmail != window.store.state.auth.employee.empEmail){
                      next("/request")
                    }
                    next();
                  }
                  else next("/request")
                });

            },
            children:[
              {
                path: '',
                component: SelectIdc
              },
              {
              name: 'selectIdc',
              path: 'selectIdc',
              component: SelectIdc,
              },
              {
                name: 'agree',
                path: 'agree',
                component: Agree,
                props: true
              },
              {
                name: 'inputInfo',
                path: 'inputInfo',
                component: InputInfo,
                props: true
              },
              {
                name: 'checkInfo',
                path: 'checkInfo',
                component: CheckInfo,
                props: true
              }
            ],
          },
          {
            name: 'secureLevel',
            path: '/app/secureLevel',
            component: SecureLevel
          },
          {
            name: 'notice',
            path: '/app/notice',
            component: Board
          },
          {
            name: 'noticeDetail',
            path: '/app/notice/:id',
            component: Board
          },
          {
            name: 'privacyPolicy',
            path: '/app/privacyPolicy',
            component: PrivacyPolicy
          },
          {
            name: 'privacyPolicyDetail',
            path: '/app/privacyPolicy/:id',
            component: PrivacyPolicy
          },
          {
            name: 'infou',
            path: '/app/infou',
            component: Infou
          },
          {
            name: 'infouDetail',
            path: '/app/infou/:id',
            component: Infou
          },
          // {
          //   name: 'requestLookup',
          //   path: '/app/requestLookup',
          //   component: () => import(/* webpackChunkName: "inout" */ '../views/app/RequestLookup.vue')
          // },
          {
            name: 'user',
            path: '/app/user',
            component: User
          },
          {
            name: 'inOut.bookList',
            path: '/app/inOut/BookList',
            component: () => import(/* webpackChunkName: "inout" */ '../views/app/InOut.vue')
          },
          {
            name: 'inOut.manager',
            path: '/app/inOut/Manager',
            component: () => import(/* webpackChunkName: "inout" */ '../views/app/InOut.vue')
          },

          {
            path: 'complience',
            name: 'complience',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/complience/Complience.vue')
          },
          {
            path: 'siteManager',
            name: 'siteManager',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/siteManager/SiteManager.vue')
          },
          {
            path: 'location',
            name: 'location',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/Location.vue')
          },
          {
            path: 'selectlocation',
            name: 'selectlocation',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/SelectLocation.vue'),
            props: true
          },
          {
            path: 'calendar',
            name: 'calendar',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/Calendar.vue')
          },
          {
            path: 'statistics',
            name: 'statistics',
            component: () => import(/* webpackChunkName: "about" */ '../views/app/statistics/Statistics.vue')
          },
          {
            path: '/app/booking/calendar',
            name: 'bookingCalendar',
            component: () => import('../views/app/booking/Calendar')
          },
          {
            path: '/app/manager/booking/calendar',
            name: 'bookingCalendarManager',
            component: () => import('../views/app/booking/Calendar')
          },
          {
            path: 'approver',
            name: 'approver',
            component: () => import( '../views/app/approver/Approver.vue')
          },
          {
            path: 'workPermit/list',
            name: 'workPermitList',
            component: () => import('../views/app/workPermit/WorkPermitList.vue')
          },
          {
            path: 'accessLog/list',
            name: 'accessLogList',
            component: () => import('../views/app/log/AccessLogList.vue')
          },
          {
            path: '/app/daily-permit/detail',
            name: 'dailyPermitDetail',
            component: () => import('../views/dailyPermit/DailyPermitDetail.vue')
          },
          {
            path: 'workPermit',
            component: () => import('../views/app/workPermit/WorkPermitMain.vue'),
            redirect: 'workPermit/agree',
            beforeEnter: (to, from, next) => {
              // 신규 안전작업 신청 진입(약관/입력)만 발주담당자 인증 토큰 필요.
              // 확인(check)·검토(review)·조회(목록→계획번호, planId 조회)는 제외
              //  — 신청 흐름은 이미 약관/입력에서 인증됨, 조회/검토는 사내 흐름.
              const gated = to.name === 'workPermitAgree' || to.name === 'workPermitInput';
              if (!gated) { next(); return; }
              // 토큰 없으면 출입신청과 동일하게 이름+이메일 인증 페이지로 유도.
              const token = window.store.getters['auth/data'];
              if (!token) {
                next({ path: '/request', query: { flow: 'workPermit' } });
                return;
              }
              window.store.dispatch('auth/validation').then((ok) => {
                if (ok) next();
                else next({ path: '/request', query: { flow: 'workPermit' } });
              });
            },
            children: [
              {
                path: 'agree',
                name: 'workPermitAgree',
                component: () => import('../views/app/workPermit/WorkPermitAgree.vue')
              },
              {
                path: 'input',
                name: 'workPermitInput',
                component: () => import('../views/app/workPermit/WorkPermit.vue')
              },
              {
                path: 'check',
                name: 'workPermitCheck',
                component: () => import('../views/app/workPermit/WorkPermitCheck.vue')
              },
              {
                path: 'review',
                name: 'workPermitReview',
                // check 페이지와 동일한 컴포넌트 사용. route name 으로 mode 분기.
                component: () => import('../views/app/workPermit/WorkPermitCheck.vue')
              }
            ]
          }
        ]
      }
    ],
  },
  // {
  //   path: '/lib/*'
  // },
  {
    path: '*',
    redirect: '/'
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  //사원 정보 체크
  async function checkLevel(){
    var a = to;
    var b = from;
    var login = await window.store.dispatch("login/LOGIN");

    //권한 처리 영역
    // if(login) {

      if(window.store.state.location.idcList == null) {
        window.store.dispatch('location/setIdcList', window.store.state.login.empNumber).then(() => {
          //LNB 에 현재 선택 된 IDC 가 없을 경우 login 주 IDC 로 설정(로그인 된 사용자만 주IDC 정보를 가지고 있음
          if(window.store.getters['location/currentIdc'] == null && window.store.state.login.empNumber != null){
            //로그인된 사용자의 주IDC 코드를 받아와 IDC 정보를 설정함
            if(window.store.state.location.idcList) {
              let currentIdc = window.store.state.location.idcList.filter((data) => {
                return data.locationCode == window.store.getters['login/getDefaultIdcCode'];
              })[0];

              window.store.dispatch('location/setCurrentIdc', currentIdc);
            }
            // next();
          }
          // next();
          checkAuth(to, from, next);
        }).catch(() => { checkAuth(to, from, next); });
      }
      else{
        // next();
        checkAuth(to, from, next);
      }


    // }



  }

  function checkAuth(to, from, next){
    if(to.path == '' || to.path == '/' || to.path == '/home' || to.path == '/app/notice' || to.path == '/request' || to.path=='/monitor/l7check' || (to.name=='noticeDetail' && to.query.mode=='view')) {
      next();
      return ;
    }

    //var userLv = 4;
    var userLv = window.store.state.login.userLevel;
    if(userLv == null) userLv = 1;

    // 안전작업관리자 전용 화면: 레벨 체계와 '별개 축' 이다. 레벨 화이트리스트로 판정하지 않는다.
    //  - 레벨 4(전체 관리자)여도 설정 명단(안전담당자 ∪ 소방담당자)에 없으면 막는다.
    //  - 반대로 명단에 있으면 레벨이 낮아도(출입관리 권한을 뺀 레벨 1) 통과시킨다.
    //    안전작업관리자에게는 출입관리 접근을 막으려고 레벨을 낮춰 부여하기 때문에,
    //    아래 레벨 화이트리스트까지 흘려보내면 lv1 목록에 없어서 되레 막혀버린다.
    var safetyManagerOnly = ['workPermitList'];
    if(safetyManagerOnly.indexOf(to.name) >= 0){
      if(window.store.state.login.safetyWorkManager){
        next();
      }else{
        next(from && from.path ? from.path : '/home');
      }
      return;
    }
    var lv0 = ['bookingCalendarManager','bookingCalendar','selectlocation','selectIdc', 'agree', 'inputInfo', 'checkInfo','infou', 'workPermitAgree', 'workPermitInput', 'workPermitCheck', 'workPermitReview', 'dailyPermitAuth', 'dailyPermitInput', 'dailyPermitDetail', 'dailyPermitView'];
    var lv1 = ['home', 'notice', 'request', 'qrScan','manualEnter','employeeRequest', 'selectIdc', 'agree', 'inputInfo', 'checkInfo', 'selectlocation','infou', 'bookingCalendar', 'workPermitAgree', 'workPermitInput', 'workPermitCheck', 'workPermitReview', 'dailyPermitAuth', 'dailyPermitInput', 'dailyPermitDetail', 'dailyPermitView'];
    var lv2 = lv1.concat(['inOut.manager', 'inOut.bookList', 'calendar', 'statistics']);
    var lv3 = lv2.concat(['user','complience','privacyPolicy']);
    var lv4 = [];
    var level = {lv0: lv0, lv1: lv1, lv2: lv2, lv3: lv3}


    if(level && level['lv' + userLv]){
      if(userLv == 2){
        level.lv2.push('bookingCalendarManager');
      }

      if(userLv >= 4) {

      }else{
        if(level['lv' + userLv].filter((x)=>x == to.name).length > 0){

        }else{
          // 권한 없는 라우트: 안내 alert 없이 조용히 이전(또는 홈)으로 되돌림.
          // (권한 없는 메뉴는 애초에 노출되지 않으므로 여기 도달하는 건 직접 URL 접근 등뿐)
          next(from && from.path ? from.path : '/home');
          return;
        }
      }
    }
    next();
  }

  checkLevel();

  //var login = await window.store.dispatch("login/LOGIN");

  /*
  window.store.dispatch("login/LOGIN")
    .then(() => {
      //IDC store에 IDC 정보가 없으면 세팅 : emp 권한 있는 IDC 정보만 설정
      var permit = ['notice', 'requestLookup'];
      debugger;
      if(window.store.state.location.idcList == null) {

        window.store.dispatch('location/setIdcList', window.store.state.login.empNumber).then(() => {
          //LNB 에 현재 선택 된 IDC 가 없을 경우 login 주 IDC 로 설정(로그인 된 사용자만 주IDC 정보를 가지고 있음
          if(window.store.getters['location/currentIdc'] == null && window.store.state.login.empNumber != null){
            //로그인된 사용자의 주IDC 코드를 받아와 IDC 정보를 설정함
            if(window.store.state.location.idcList) {
              let currentIdc = window.store.state.location.idcList.filter((data) => {
                return data.locationCode == window.store.getters['login/getDefaultIdcCode'];
              })[0];

              window.store.dispatch('location/setCurrentIdc', currentIdc);
            }
            next();
          }
          next();
        })
      }else{
        var permit = ['notice', 'requestLookup'];
        debugger;
        next();
      }

  })
  */

});



export default router
